<template>
	<div>
		<div class="editor-enunciado">
			{{ title }}
			<div class="button-container">
				<div v-show="mathmlView" class="textarea-container">
					<h3>Inserir MathML</h3>
					<textarea
						v-model="textareaInfo"
						class="textearea-box"
						cols="30"
						rows="10"
					></textarea>

					<div class="button-textarea">
						<button
							v-on:click.prevent="closeAndClearTextAreaInfo()"
							style="background-color: #cd5151;"
							class="visualizar"
						>
							<span class="texto-visualizar">Fechar</span>
						</button>

						<button
							style="background-color: #15adbc;"
							v-on:click.prevent="mathmlView = false"
							class="visualizar"
							v-on:click="clearForm()"
						>
							<span class="texto-visualizar">Limpar</span>
						</button>

						<div class="tooltip">
							<span class="tooltiptext">Inserir MathML para Enviar</span>
							<div
								v-if="textareaInfo.length === 0"
								class="visualizar-disable"
							>
								<span class="texto-visualizar">Enviar</span>
							</div>
						</div>

						<button
							v-show="textareaInfo.length > 0"
							v-on:click.prevent="convert(textareaInfo)"
							class="visualizar"
						>
							<span class="texto-visualizar">Enviar</span>
						</button>
					</div>
				</div>

				<button v-on:click.prevent="getPreview()" class="visualizar">
					<i class="fas fa-eye"></i
					><span class="texto-visualizar">{{
						preview ? "Ocultar" : "Visualizar"
					}}</span>
				</button>
				<button
					v-show="route === 'questoesEdit' && this.delete === true"
					v-on:click.prevent="removeAlt"
					class="visualizar-excluir"
				>
					<i class="fas fa-trash"></i
					><span class="texto-visualizar">Excluir</span>
				</button>
			</div>
		</div>

		<div class="mathml-vue2editor">
			<button
				v-show="route === 'questoesEdit'"
				v-on:click.prevent="changeModal()"
				class="visualizar-mathml"
			>
				<div class="tooltip">
					<span class="tooltiptext">Inserir MathML</span>
					<span class="material-icons icone-mathml">functions</span>
				</div>
			</button>
			<VueEditor id="teste" v-model="content"></VueEditor>
		</div>
		<iframe
			:srcdoc="iframeContent"
			v-show="preview"
			class="iframe-box"
			frameborder="0"
		></iframe>
	</div>
</template>

<script>
import Mathml2latex from 'mathml-to-latex'
// Não remover '\' no fechamento do script
// eslint-disable-next-line
const script = '<script type="text/javascript" id="MathJax-script" async src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js"><\/script>'
// eslint-disable-next-line
const config = 	'<script> MathJax = { tex: { inlineMath: [["$", "$"], ["\\(", "\\)"], ["\\\\\\\\", "\\\\\\\\"]] }, svg: { fontCache: "global" } }<\/script>' // '\\\\\\\\' => \\

export default {
	name: 'MathQuestionEditor',
	props: {
		route: String, // importante para renderização no local especifico da rota;
		title: String, // texto para aparecer no topo do componente;
		show: String, // valor a ser atribuido ao iframe no carregamento da API;
		id: String, // valor atribuido de forma aleatória, deve estar consistente com o switch na pagina de destino;
		index: Number, // valor a ser passado caso esteja dentro de um v-for;
		info: Function, // funcão de saída de valores para o pai;
		removeAlt: Function, // fução de bind para remover alternativas no v-for;
		delete: Boolean // adiciona o botão de excluir;
	},
	data () {
		return {
			mathmlView: false,
			textareaInfo: '',
			preview: false,
			content: this.show,
			iframeContent:
				script +
				config +
				`<div class='mathjax'>${this.show}</div><style> .mathjax{ font-size: 20px;} img {object-fit: contain; width: 100%;}; </style>`
		}
	},
	watch: {
		content () {
			const concat =
				config +
				script +
				`<div class='mathjax'>${this.content}</div><style> .mathjax{ font-size: 20px;}  img {object-fit: contain; width: 100%;};</style>`
			this.iframeContent = concat
			this.info(this.id, this.content, this.index)
		}
	},
	methods: {
		convert (value) {
			this.content = this.content + '$' + Mathml2latex.convert(value) + '$'
			this.mathmlView = false
			this.textareaInfo = ''
		},
		getPreview () {
			this.preview = !this.preview
		},
		changeModal () {
			this.mathmlView = !this.mathmlView
		},
		clearForm () {
			this.textareaInfo = ''
			this.mathmlView = true
		},
		closeAndClearTextAreaInfo () {
			this.mathmlView = false
			this.textareaInfo = ''
		}
	}
}
</script>

<style lang="scss" scoped>
.editor-enunciado {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px;
	background-color: #f3f3f3;
	color: #707070;
	font-family: $font-family-alternative;
	font-size: 18px;
	font-weight: bold;
}

.button-container {
	display: flex;
	position: relative;
	gap: 10px;
}

.textarea-container {
	position: absolute;
	border: 1px solid #f3f3f3;
	border-radius: 5px;
	box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
	background-color: #fff;
	padding: 15px;
	left: -320px;
	transition: display 0.3s;
	z-index: 2;
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 10px;

	.textearea-box {
		border: 1px solid #f3f3f3;
		padding: 5px;
	}

	.button-textarea {
		display: flex;
		width: 100%;
		justify-content: flex-end;
		gap: 10px;
	}
}

.mathml-vue2editor {
	position: relative;

	.visualizar-mathml {
		position: absolute;
		right: 5px;
		top: 10px;
		border: none;
		outline: none;
		background: none;
		cursor: pointer;
		z-index: 1;

		.icone-mathml {
			cursor: pointer;
			color: #444444;
		}

		.icone-mathml:hover {
			color: #0066cc;
		}
	}
}

.visualizar {
	border: none;
	outline: none;
	background-color: #018033;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	height: 38px;
	width: 95px;
	color: #fff;
	font-size: 15px;
	font-weight: lighter;
	transition: opacity 0.1s;
	padding: 0 10px 0 10px;
	cursor: pointer;
}

.visualizar-disable {
	border: none;
	outline: none;
	background-color: #018033;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	height: 38px;
	width: 95px;
	color: #fff;
	font-size: 15px;
	font-weight: lighter;
	transition: opacity 0.1s;
	padding: 0 10px 0 10px;
	opacity: 0.5;
}

.texto-visualizar {
	font-family: $font-family-alternative;
}

.active:before {
	content: "Visualizar";
}
.off:before {
	content: "Ocultar";
}

.visualizar:hover {
	opacity: 0.9;
}

.visualizar-excluir {
	border: none;
	outline: none;
	background-color: #c93f3f;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	height: 38px;
	color: #fff;
	font-size: 15px;
	font-weight: lighter;
	transition: opacity 0.1s;
	padding: 0 10px 0 10px;
	cursor: pointer;
}

.visualizar-excluir:hover {
	opacity: 0.9;
}

.tooltip {
	position: relative;
	display: inline-block;
}

.tooltip .tooltiptext {
	visibility: hidden;
	width: 120px;
	background-color: #555;
	color: #fff;
	text-align: center;
	font-size: 12px;
	border-radius: 6px;
	padding: 5px 0;
	position: absolute;
	z-index: 1;
	bottom: 125%;
	left: 50%;
	margin-left: -60px;
	opacity: 0;
	transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
	content: "";
	position: absolute;
	top: 100%;
	left: 50%;
	margin-left: -5px;
	border-width: 5px;
	border-style: solid;
	border-color: #555 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
	visibility: visible;
	opacity: 1;
}

.alert {
  padding: 20px;
  background-color: #f44336;
  color: white;
}

.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: black;
}

.iframe-box {
		display: flex;
		width: 100%;
		height: 300px;
		border: solid 1px #f3f3f3;
	}
</style>
